// // import { Facebook, Instagram, Twitter } from 'lucide-react';

// // export default function Footer() {
// //   return (
// //     <footer className="bg-secondary-dark text-white py-8">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <div className="grid md:grid-cols-3 gap-8">
// //           {/* Company Info */}
// //           <div>
// //             <h3 className="text-3xl font-heading font-bold text-accent-base mb-4">Capital Offset</h3>
// //             <p className="text-gray-300 mb-4">
// //               We provide high-quality printing services in Ahmedabad, specializing in brochure, book, box, and more. With years of expertise, we deliver professional solutions for businesses across various industries.
// //             </p>
// //             <p className="text-gray-300">
// //               <strong>Contact Us:</strong><br />
// //               1234 Printing Lane, Ahmedabad, Gujarat, India <br />
// //               Phone: +91 123 456 7890<br />
// //               Email: <a href="mailto:info@satyamscan.com" className="text-accent-light hover:text-white">info@satyamscan.com</a>
// //             </p>
// //           </div>

// //           {/* Quick Links */}
// //           <div>
// //             <h3 className="text-2xl font-bold text-accent-base mb-4">Quick Links</h3>
// //             <ul className="space-y-2 text-gray-300">
// //               <li>
// //                 <a href="/" className="hover:text-accent-light transition-colors duration-300">Home</a>
// //               </li>
// //               <li>
// //                 <a href="/about" className="hover:text-accent-light transition-colors duration-300">About Us</a>
// //               </li>
// //               <li>
// //                 <a href="/services" className="hover:text-accent-light transition-colors duration-300">Services</a>
// //               </li>
// //               <li>
// //                 <a href="/portfolio" className="hover:text-accent-light transition-colors duration-300">Portfolio</a>
// //               </li>
// //               <li>
// //                 <a href="/contact" className="hover:text-accent-light transition-colors duration-300">Contact</a>
// //               </li>
// //             </ul>
// //           </div>

// //           {/* Social Media Links */}
// //           <div>
// //             <h3 className="text-2xl font-bold text-accent-base mb-4">Follow Us</h3>
// //             <div className="flex space-x-6">
// //               <a href="https://www.facebook.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Facebook className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.instagram.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Instagram className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.twitter.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Twitter className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.linkedin.com/company/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Twitter className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="border-t border-gray-700 mt-8 pt-6">
// //           <div className="flex justify-between items-center">
// //             <p className="text-gray-300 text-sm">&copy; 2025 Capital Offset. All rights reserved.</p>
// //             <div className="text-sm text-gray-300">
// //               <a href="/privacy-policy" className="hover:text-accent-light transition-colors duration-300 mr-4">Privacy Policy</a>
// //               <a href="/terms-of-service" className="hover:text-accent-light transition-colors duration-300">Terms of Service</a>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // }

// import { Facebook, Instagram, Twitter } from 'lucide-react';
// import { Link } from 'react-router-dom';

// export default function Footer() {
//   return (
//     <footer className="bg-primary-dark text-white py-10">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Logo Section */}
//         <div className="flex items-center justify-center md:justify-start mb-8">
//           <Link href="/">
//             <a>
//               <img src="/logo.png" alt="Satyamscan" className="w-32" />
//             </a>
//           </Link>
//         </div>

//         {/* Footer Grid */}
//         <div className="grid md:grid-cols-3 gap-12">
//           {/* Company Info */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">About Satyamscan</h3>
//             <p className="text-gray-300 mb-4">
//               We provide premium quality printing services in Ahmedabad, specializing in a wide range of products such as brochures, books, and packaging. Our goal is to deliver exceptional results to our clients with precision and professionalism.
//             </p>
//             <p className="text-gray-300">
//               <strong>Contact Us:</strong><br />
//               1234 Printing Lane, Ahmedabad, Gujarat, India <br />
//               Phone: <a href="tel:+911234567890" className="text-accent-light hover:text-white">+91 123 456 7890</a><br />
//               Email: <a href="mailto:info@satyamscan.com" className="text-accent-light hover:text-white">info@satyamscan.com</a>
//             </p>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">Quick Links</h3>
//             <ul className="space-y-3 text-gray-300">
//               <li>
//                 <Link href="/">
//                   <a className="hover:text-accent-light transition-colors duration-300">Home</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/about">
//                   <a className="hover:text-accent-light transition-colors duration-300">About Us</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/services">
//                   <a className="hover:text-accent-light transition-colors duration-300">Services</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/portfolio">
//                   <a className="hover:text-accent-light transition-colors duration-300">Portfolio</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/contact">
//                   <a className="hover:text-accent-light transition-colors duration-300">Contact</a>
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           {/* Social Media Links */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">Follow Us</h3>
//             <div className="flex space-x-6">
//               <a href="https://www.facebook.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
//                 <Facebook className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.instagram.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
//                 <Instagram className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.twitter.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
//                 <Twitter className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.linkedin.com/company/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
//                 <Twitter className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* Legal Links */}
//         <div className="border-t border-gray-700 mt-12 pt-8">
//           <div className="flex justify-between items-center">
//             <p className="text-gray-300 text-sm">
//               &copy; 2025 Satyamscan. All rights reserved.
//             </p>
//             <div className="text-sm text-gray-300 space-x-4">
//               <Link href="/privacy-policy">
//                 <a className="hover:text-accent-light transition-colors duration-300">Privacy Policy</a>
//               </Link>
//               <Link href="/terms-of-service">
//                 <a className="hover:text-accent-light transition-colors duration-300">Terms of Service</a>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Code, Award } from 'lucide-react';
import { Link } from 'react-router-dom'; // For routing links
import logo from '../assets/1.png'
import { FiFacebook, FiGithub, FiInstagram, FiLinkedin, FiMail, FiMapPin, FiPhone, FiTwitter } from 'react-icons/fi';
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12 border-b border-gray-800 pb-12">
        <div>
          <div className="flex justify-center space-x-2 ">
            <img src={logo} className="text-yellow-500 h-24 w-auto" />
            
          </div>
          <p className="text-gray-400 text-center mb-6">
            Your trusted partner in precious <br/> metals trading and investment services.
          </p>
        </div>
        
        <div className='text-center'>
          <h4 className="text-lg font-bold mb-6 text-yellow-500 ">Quick Links</h4>
          <ul className="space-y-3">
            <li><Link to='/' className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
            <li><Link to='/services' className="text-gray-400 hover:text-white transition-colors">Services</Link></li>
            <li><Link to='/about' className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
            <li><Link to='/' className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>
        
        {/* <div>
          <h4 className="text-lg font-bold mb-6 text-yellow-500">Services</h4>
          <ul className="space-y-3">
            <li><Link to='#' className="text-gray-400 hover:text-white transition-colors">Import & Export</Link></li>
            <li><Link to='#' className="text-gray-400 hover:text-white transition-colors">Market Analysis</Link></li>
            <li><Link to='#' className="text-gray-400 hover:text-white transition-colors">Global Logistics</Link></li>
            <li><Link to='#' className="text-gray-400 hover:text-white transition-colors">Compliance Consulting</Link></li>
            <li><Link to='#' className="text-gray-400 hover:text-white transition-colors">Investment Advisory</Link></li>
          </ul>
        </div> */}
        
        <div className='text-center'>
          <h4 className="text-lg font-bold mb-6 text-yellow-500">Contact Us</h4>
          <ul className="space-y-4 text-gray-400">
            <li className="flex justify-center">
              <span className="mr-2">📍</span>
              <span>Australia</span>
            </li>
            <li className="flex justify-center">
              <span className="mr-2">📧</span>
              <span>info@pvgimportexport.com.au</span>
            </li>
            <li className="flex justify-center">
              <span className="mr-2">📞</span>
              <span>+61 411243525</span>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="">
        <div className="flex flex-col md:flex-row md:justify-between md:items-between">
          <p className="text-gray-500 mb-4 md:mb-0">
            © 2025 PVG Import Export. All rights reserved.
          </p>
          <div className="flex space-x-6">
              <a href="https://www.instagram.com/pvgimportexport/" className="text-gray-500  hover:text-yellow-500">
                <FiInstagram className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/pvg-import-export/" className="text-gray-500  hover:text-yellow-500">
                <FiLinkedin className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61574469751134" className="text-gray-500 hover:text-yellow-500">
                <FiFacebook className="w-5 h-5" />
              </a>
             
            </div>
        </div>
      </div>
    
    </div>
  </footer>
  );
};

export default Footer;
